import { enqueueSnackbar } from "notistack";
import {  PPTRuleRequest, PPTRules, PPTRulesCategorisation, PPTRulesDescription, PPTRulesResponse, ServerAPIResponse, UpdatePPTRulesDescriptionCategorisationRequest } from "../helpers/interfaces";
import { callServerAPI, showBackDrop } from "../helpers/utils";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { ReportType } from "../helpers/constants";

const MySwal = withReactContent(Swal);

export const getAllPPTRules = async (reportType:string , year:string) => {
    return await new Promise<PPTRules[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading PPT Rules"));
        callServerAPI<ServerAPIResponse<PPTRules[]>>('GET',  `/api/v1/PPTRules?reportType=${reportType}&year=${year}&PageSize=50&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}



export async function createPPTRules(pptRulesRequest: PPTRuleRequest) {
    return await new Promise<PPTRules[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Adding PPTRules"));
        callServerAPI<ServerAPIResponse<PPTRules[]>>('POST', `/api/v1/PPTRules?api-version=1`, pptRulesRequest, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("PPT DisAllowed Costs Created", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function createPPTRulesFromPreviousYear(fromYear:string, toYear:string, reportType:ReportType) {
    return await new Promise<PPTRules[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Adding PPTRules"));
        callServerAPI<ServerAPIResponse<PPTRules[]>>('POST', `/api/v1/PPTRules/CreatePPTRulesFromPreviousYear?FromYear=${fromYear}&ToYear=${toYear}&reportType=${reportType}&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("PPT DisAllowed Costs Created", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function updatePPTRules(pptRulesDescriptionCategorisationRequests: UpdatePPTRulesDescriptionCategorisationRequest[]) {
    return await new Promise<PPTRules[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Adding PPTRules"));
        callServerAPI<ServerAPIResponse<PPTRules[]>>('POST', `/api/v1/PPTRules/UpdatePPTRulesDescriptionCategorisation?api-version=1`, {pptRulesDescriptionCategorisationRequests: pptRulesDescriptionCategorisationRequests}, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("PPT DisAllowed Costs Updated", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function createPPTRulesDescription(name: string, order: number, reportType: ReportType , year:string) {
    const descriptionData = {
        name: name,
        order: order,
        reportType: reportType
    }
    return await new Promise<PPTRulesDescription>(async (resolve, reject) => {
        
        MySwal.fire(showBackDrop("Creating DisAllowed Costs"));
        callServerAPI<ServerAPIResponse<PPTRulesDescription>>('POST', `/api/v1/PPTRulesDescription?api-version=1&year=${year}`, descriptionData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("PPT DisAllowed Costs Created", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function updatePPTRulesDescription(id: string, name: string, order: number) {
    const descriptionData = {
        name: name,
        order: order
    }
    return await new Promise<PPTRulesDescription>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Updating DisAllowed Costs"));
        callServerAPI<ServerAPIResponse<PPTRulesDescription>>('PUT', `/api/v1/PPTRulesDescription?id=${id}&api-version=1`, descriptionData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("DisAllowed Costs Updated", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function deletePPTRulesDescription(id: string) {
    return await new Promise<void>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Deleting DisAllowed Cost"));
        await callServerAPI<any>('DELETE', `/api/v1/PPTRulesDescription?id=${id}&api-version=1`, null, true)
            .then(response => {
                MySwal.close()

                resolve()
            })
    })
}

export const getAllPPTRulesDescription = async (reportType:ReportType, year:string) => {
    return await new Promise<PPTRulesDescription[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading PPT Rules Description"));
        callServerAPI<ServerAPIResponse<PPTRulesDescription[]>>('GET',  `/api/v1/PPTRulesDescription?ReportType=${reportType}&year=${year}&PageSize=50&api-version=1`, null, true)
            .then(response => {
                
                MySwal.close()
                resolve(response.data.data)
            })
    })
}

export const getAllPPTRulesCategorisation = async (reportType:ReportType, year:string) => {
    return await new Promise<PPTRulesCategorisation[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading PPT Rules Categorisation"));
        callServerAPI<ServerAPIResponse<PPTRulesCategorisation[]>>('GET',  `/api/v1/PPTRulesCategorisation?ReportType=${reportType}&year=${year}&PageSize=50&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}

export async function createPPTRulesCategorisation(name: string, order: number, reportType: ReportType, year:string) {
    const descriptionData = {
        name: name,
        order: order,
        reportType: reportType
    }
    return await new Promise<PPTRulesCategorisation>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Creating PPT Rules Categorisation"));
        callServerAPI<ServerAPIResponse<PPTRulesCategorisation>>('POST', `/api/v1/PPTRulesCategorisation?api-version=1&year=${year}`, descriptionData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("PPT Rules Categorisation Created", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function updatePPTRulesCategorisation(id: string, name: string, order: number) {
    const descriptionData = {
        name: name,
        order: order
    }
    return await new Promise<PPTRulesCategorisation>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Updating PPT Rules Categorisation"));
        callServerAPI<ServerAPIResponse<PPTRulesCategorisation>>('PUT', `/api/v1/PPTRulesCategorisation?id=${id}&api-version=1`, descriptionData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("PPT Rules Categorisation Updated", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function deletePPTRulesCategorisation(id: string) {
    return await new Promise<void>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Deleting PPT Rules Categorisation"));
        await callServerAPI<any>('DELETE', `/api/v1/PPTRulesCategorisation?id=${id}&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                
                resolve()
            })
    })
}


export const getPPTReports = async (reportType:ReportType, year:Number ,upload: File) => {
    const formData = new FormData();
    formData.append('ExcelFile', upload);
    return await new Promise<PPTRulesResponse>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading PPT Report"));
        callServerAPI<ServerAPIResponse<PPTRulesResponse>>('POST',  `/api/v1/PPTReports/GetPPTReports?reportType=${reportType}&api-version=1&year=${year}`, formData, true)
            .then(response => {
                console.log(response.data.data,'response')
                MySwal.close()
                resolve(response.data.data)
            })
    })
}
